module.exports = __webpack_public_path__ + "fonts/Roboto-Bold-webfont.8b18d65d.woff";